// extracted by css-extract-rspack-plugin
export default {"root":"xS4C0"};